export default "__VITE_ASSET__1295f97d__"